<div class="header">
    <div flex fxLayout="row">
      <div fxFlex="100">
          <h1>Reservas</h1>
      </div>
    </div>
    
    <div flex fxLayout="row" class="">
        <div fxFlex="50" class="pt-3">
            <button type="button" mat-raised-button color="primary" class="btn-action" (click)="newReserva()" [disabled]="btnReservaDisabled">Reservar Turno</button>
            <button type="button" mat-raised-button color="white" class="ml-2" routerLink='/reservas'><i class="material-icons">date_range</i> Grilla Turnos</button>
        </div>

        <div fxFlex="30" class="text-right pt-2">
            <span class="pr-2">Estado:</span>
            <mat-form-field>
                <mat-select [(ngModel)]="fStatus" (selectionChange)="filterStatus()">
                    <mat-option [value]="0">Todos</mat-option>
                    <mat-option [value]="1">Confirmada</mat-option>
                    <mat-option [value]="2">Cancelada</mat-option>
                    <mat-option [value]="3">Terminado</mat-option>
                    <mat-option [value]="4">Jugando</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxFlex="30" class="text-right pt-2 ml-4">
            <mat-form-field class="w-100">
                <input matInput placeholder="Filtrar por Cancha, Organizador o Fecha" #searchInput>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>            
        </div>
    </div>
</div>

<div class="content">
        <div class="mat-elevation-z8">
            <div class="spinner-container text-center" *ngIf="dataSource.loading$ | async">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
        
            <table mat-table [dataSource]="dataSource" class="table"
                    matSort matSortActive="id" matSortDirection="asc" matSortDisableClear>
            
                <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="start_time"> Fecha </th>
                    <td width="250" class="link" mat-cell *matCellDef="let element" (click)="openReserva(element)">{{element.start_time| date: 'dd/MM/yyyy'}}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="status"> Estado </th>
                    <td mat-cell *matCellDef="let element" class="status-{{element.status}} mat-cell">{{element.status}}</td>
                </ng-container>
                <ng-container matColumnDef="planner">
                    <th width="300" mat-header-cell *matHeaderCellDef mat-sort-header="planner"> Organizador </th>
                    <td mat-cell *matCellDef="let element"> {{ element.name || element.planner }} </td>
                </ng-container>
                <ng-container matColumnDef="cancha">
                    <th width="300" mat-header-cell *matHeaderCellDef> Cancha </th>
                    <td mat-cell *matCellDef="let element">{{ element.field.name }}</td>
                </ng-container>
                <ng-container matColumnDef="jugadores">
                    <th width="100" mat-header-cell *matHeaderCellDef> Jugadores </th>
                    <td mat-cell *matCellDef="let element"> x </td>
                </ng-container>
                <ng-container matColumnDef="more">
                    <th width="30" mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element" width="20"><i class="material-icons">more_vert</i></td>
                </ng-container>
            
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        
            </table>
        
            <mat-paginator [length]="dataSource.total" [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
        
        </div>
    </div>

